/** Session 8 Block 3 · Compact operator hub. */
import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import {
  Card, CardContent, CardHeader, CardTitle,
} from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";


export function OperatorFeatureFlags() {
  const [flags, setFlags] = useState([]);
  useEffect(() => {
    api.get("/operator/feature-flags-plus").then(
      (r) => setFlags(r.data.flags || [])).catch(() => {});
  }, []);
  return (
    <div className="p-6 max-w-4xl mx-auto space-y-4"
          data-testid="operator-flags-page">
      <h1 className="text-2xl font-semibold">Feature-Flags</h1>
      <div className="space-y-2">
        {flags.map((f) => (
          <Card key={f.flag_key}
                 data-testid={`flag-card-${f.flag_key}`}>
            <CardHeader className="pb-2">
              <CardTitle className="text-base flex justify-between">
                <span>{f.flag_key}</span>
                <Badge variant="secondary">{f.type}</Badge>
              </CardTitle>
            </CardHeader>
            <CardContent className="text-sm">
              <div className="text-muted-foreground">
                Default: <code>{JSON.stringify(f.default_value)}</code>
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                {f.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}


export function OperatorOperators() {
  const [ops, setOps] = useState([]);
  const [email, setEmail] = useState("");
  const load = () =>
    api.get("/operator/operators").then(
      (r) => setOps(r.data.operators || [])).catch(() => {});
  useEffect(load, []);
  const invite = async () => {
    if (!email) return;
    try {
      const r = await api.post("/operator/operators/invite",
                                 { email, expires_in_days: 7 });
      const url = r.data.invitation_url;
      navigator.clipboard?.writeText(window.location.origin + url);
      toast.success("Invitation-Link kopiert.");
      setEmail(""); load();
    } catch (e) {
      toast.error(e.response?.data?.detail?.error || "invite_failed");
    }
  };
  return (
    <div className="p-6 max-w-4xl mx-auto space-y-4"
          data-testid="operator-operators-page">
      <h1 className="text-2xl font-semibold">Operatoren</h1>
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Neuen Operator einladen</CardTitle>
        </CardHeader>
        <CardContent className="flex gap-2">
          <Input value={email} placeholder="new-op@example.com"
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="invite-email-input" />
          <Button onClick={invite}
                    data-testid="btn-invite-operator">
            Einladen (Link kopieren)
          </Button>
        </CardContent>
      </Card>
      <div className="space-y-2">
        {ops.map((o) => (
          <Card key={o.id} data-testid={`op-row-${o.id}`}>
            <CardContent className="flex items-center justify-between p-4">
              <div>
                <div className="font-medium">{o.email_masked}</div>
                <div className="text-xs text-muted-foreground">
                  {o.full_name}
                </div>
              </div>
              <div className="flex gap-2">
                {o.is_bootstrap && (
                  <Badge variant="secondary"
                          data-testid={`op-badge-bootstrap-${o.id}`}>
                    Bootstrap
                  </Badge>
                )}
                <Badge className={o.is_active
                  ? "bg-emerald-100 text-emerald-800 border-0"
                  : "bg-muted text-muted-foreground border-0"}
                        data-testid={`op-badge-active-${o.id}`}>
                  {o.is_active ? "aktiv" : "deaktiviert"}
                </Badge>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
